<template>
  <v-container fluid class="bg-background2" style="min-height: 100dvh;">
    <v-row no-gutters class="align-baseline">

      <v-col :cols="$vuetify.display.mobile ? 12 : 4" v-bind:class="{ 'pe-4': !$vuetify.display.mobile }"
        style="top: 16px;" v-bind:style="{ 'position': ($vuetify.display.mobile) ? 'static' : 'sticky' }">

        <v-card :elevation="0" class="mb-3">
          <v-card-item>
            <v-card-title class="text-subtitle-2">操作モジュール選択</v-card-title>
          </v-card-item>

          <v-card-text class="pt-1">
            <v-select density="compact" hide-details :readonly="isConnecting || isConnected"
              v-model:model-value="moduleID" :items="operableModules"></v-select>
          </v-card-text>

          <v-card-actions class="px-4 pb-4 d-flex">
            <v-btn variant="outlined" class="flex-1-1-100" :disabled="!isConnected"
              v-on:click="disconnect">
              接続解除
            </v-btn>

            <v-btn variant="flat" color="primary" class="flex-1-1-100" :disabled="moduleID === '' || isConnected"
              v-on:click="connect" :loading="isConnecting">
              接続
            </v-btn>
          </v-card-actions>
        </v-card>

        <v-card class="mb-3" style="height: calc(100dvh - 232px);"
          v-bind:style="{ 'max-height': ($vuetify.display.mobile) ? '170px' : 'none' }">

          <v-card-text class="h-100 pe-2">
            <v-virtual-scroll height="100%" class="pe-2"
              :items="operationLogList">
              <template v-slot:default="{ item }">

                <v-divider></v-divider>

                <div class="mt-2 mb-3 px-1">
                  <div class="d-flex justify-space-between">
                    <span>
                      {{ item.timestamp }}
                    </span>
                    <span class="text-grey">
                      {{ '#' + item.payload.id }}
                    </span>
                  </div>

                  <div class="mt-1 ms-1">
                    {{ convertToFriendlyText(item.payload) }}
                  </div>
                </div>

                <v-divider></v-divider>

              </template>
            </v-virtual-scroll>
          </v-card-text>
        </v-card>

      </v-col>

      <v-col :cols="$vuetify.display.mobile ? 12 : 8" v-if="isConnected">

        <v-card class="mb-6">
          <v-card-item>
            <v-card-title class="text-subtitle-1 font-weight-bold mb-2">出力指示</v-card-title>
          </v-card-item>

          <v-card-text class="bg-background">
            <v-row>
              <v-col :cols="$vuetify.display.mobile ? 12 : 6">
                <v-card :elevation="2" class="mx-n2">
                  <v-card-item>
                    <v-card-title class="text-subtitle-1">
                      {{ output1ChannelName }}
                    </v-card-title>
                  </v-card-item>

                  <v-card-text class="pb-1">

                    <div class="mx-1 text-right">
                      <div class="text-h5">
                        {{ output1Meanings[output1Value] }}
                      </div>
                      <div class="text-subtitle-2">
                        ({{ output1Value === 1 ? 'ON' : 'OFF' }})
                      </div>
                    </div>

                    <v-divider :thickness="2" class="mt-3 mb-6"></v-divider>

                    <v-form @submit.prevent ref="output1CommandForm">

                      <v-btn-toggle variant="outlined" divided class="px-1 d-flex"
                        mandatory v-model="output1Command">
                        <v-btn color="primary" class="flex-fill" value="ON">
                          ON
                        </v-btn>
                        <v-btn class="flex-fill" value="OFF">
                          OFF
                        </v-btn>
                      </v-btn-toggle>

                      <v-checkbox label="出力継続時間を指定する" hide-details class="mt-3 mx-n1"
                        v-model="hasOutput1Duration"></v-checkbox>
                      <v-row no-gutters class="mt-1" v-if="hasOutput1Duration">
                        <v-col cols="6" class="px-1">
                          <v-text-field density="compact"
                            :suffix="(output1DurationUnit === 'mSec') ? '00' : ''"
                            :rules="[ v => (v && Number.isInteger(Number(v)) && 1 <= Number(v) && Number(v) <= 6000) || '数値（1 ～ 6000）' ]"
                            persistent-hint hint="数値（1 ～ 6000）"
                            v-model="output1Duration"></v-text-field>
                        </v-col>
                        <v-col cols="6" class="px-1">
                          <v-select density="compact" v-model:model-value="output1DurationUnit"
                            :items="[{ title: 'ミリ秒', value: 'mSec' }, { title: '秒', value: 'sec' }]"></v-select>
                        </v-col>
                      </v-row>

                    </v-form>

                  </v-card-text>

                  <v-card-actions class="px-3 pb-3 justify-end">
                    <v-btn variant="flat" color="primary"
                      v-on:click="showOutputConfirmDialog(true, false);">
                      コマンド送信
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>

              <v-col :cols="$vuetify.display.mobile ? 12 : 6">
                <v-card :elevation="2" class="mx-n2">
                  <v-card-item>
                    <v-card-title class="text-subtitle-1">
                      {{ output2ChannelName }}
                    </v-card-title>
                  </v-card-item>

                  <v-card-text class="pb-1">

                    <div class="mx-1 text-right">
                      <div class="text-h5">
                        {{ output2Meanings[output2Value] }}
                      </div>
                      <div class="text-subtitle-2">
                        ({{ output2Value === 1 ? 'ON' : 'OFF' }})
                      </div>
                    </div>

                    <v-divider :thickness="2" class="mt-3 mb-6"></v-divider>

                    <v-form @submit.prevent ref="output2CommandForm">

                      <v-btn-toggle variant="outlined" divided class="px-1 d-flex"
                        mandatory v-model="output2Command">
                        <v-btn color="primary" class="flex-fill" value="ON">
                          ON
                        </v-btn>
                        <v-btn class="flex-fill" value="OFF">
                          OFF
                        </v-btn>
                      </v-btn-toggle>

                      <v-checkbox label="出力継続時間を指定する" hide-details class="mt-3 mx-n1"
                        v-model="hasOutput2Duration"></v-checkbox>
                      <v-row no-gutters class="mt-1" v-if="hasOutput2Duration">
                        <v-col cols="6" class="px-1">
                          <v-text-field density="compact"
                            :suffix="(output2DurationUnit === 'mSec') ? '00' : ''"
                            :rules="[ v => (v && Number.isInteger(Number(v)) && 1 <= Number(v) && Number(v) <= 6000) || '数値（1 ～ 6000）' ]"
                            persistent-hint hint="数値（1 ～ 6000）"
                            v-model="output2Duration"></v-text-field>
                        </v-col>
                        <v-col cols="6" class="px-1">
                          <v-select density="compact" v-model:model-value="output2DurationUnit"
                            :items="[{ title: 'ミリ秒', value: 'mSec' }, { title: '秒', value: 'sec' }]"></v-select>
                        </v-col>
                      </v-row>

                    </v-form>

                  </v-card-text>

                  <v-card-actions class="px-3 pb-3 justify-end">
                    <v-btn variant="flat" color="primary"
                      v-on:click="showOutputConfirmDialog(false, true);">
                      コマンド送信
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="pa-4 justify-end">
            <v-btn variant="tonal" color="primary"
              v-on:click="showOutputConfirmDialog(true, true);">
              コマンド一括送信
            </v-btn>
          </v-card-actions>
        </v-card>

        <v-card class="mb-6">
          <v-card-item>
            <v-card-title class="text-subtitle-1 font-weight-bold">出力予約</v-card-title>
          </v-card-item>

          <v-card-text>
            <v-divider class="mt-n1"></v-divider>

            <div class="mt-5">
              <h4>{{ '（デジタル出力1）' + output1ChannelName }}</h4>

              <v-card variant="outlined" elevation="1" class="mx-2 my-3" v-if="output1Schedule">
                <v-card-item>
                  <v-card-title class="text-subtitle-1">
                    {{ output1Schedule.time }}
                  </v-card-title>
                </v-card-item>

                <v-card-text class="px-5">
                  <p class="text-h5 mb-3">
                    {{ output1Schedule.action.val === 1 ? 'ON' : 'OFF' }}
                  </p>

                  <div v-if="output1Schedule.action.duration">
                    <v-label class="text-subtitle-2">出力継続時間</v-label>
                    <span class="ms-3">
                      {{ (output1Schedule.action.duration % 10 === 0) ?
                        ((output1Schedule.action.duration / 10).toString() + ' 秒') : (output1Schedule.action.duration.toString() + '00 ミリ秒') }}
                    </span>
                  </div>
                </v-card-text>

                <v-card-actions class="justify-end">
                  <v-btn variant="tonal" color="error"
                    v-on:click="cancelTargetSchedule = 'do1'; isShowCancelScheduleConfirmDialog = true;">
                    キャンセル
                  </v-btn>
                </v-card-actions>
              </v-card>

              <p class="ma-4" v-else>なし</p>
            </div>

            <div class="mt-8">
              <h4>{{ '（デジタル出力2）' + output2ChannelName }}</h4>

              <v-card variant="outlined" elevation="1" class="mx-2 my-3" v-if="output2Schedule">
                <v-card-item>
                  <v-card-title class="text-subtitle-1">
                    {{ output2Schedule.time }}
                  </v-card-title>
                </v-card-item>

                <v-card-text class="px-5">
                  <p class="text-h5 mb-3">
                    {{ output2Schedule.action.val === 1 ? 'ON' : 'OFF' }}
                  </p>

                  <div v-if="output2Schedule.action.duration">
                    <v-label class="text-subtitle-2">出力継続時間</v-label>
                    <span class="ms-3">
                      {{ (output2Schedule.action.duration % 10 === 0) ?
                        ((output2Schedule.action.duration / 10).toString() + ' 秒') : (output2Schedule.action.duration.toString() + '00 ミリ秒') }}
                    </span>
                  </div>
                </v-card-text>

                <v-card-actions class="justify-end">
                  <v-btn variant="tonal" color="error"
                    v-on:click="cancelTargetSchedule = 'do2'; isShowCancelScheduleConfirmDialog = true;">
                    キャンセル
                  </v-btn>
                </v-card-actions>
              </v-card>

              <p class="ma-4" v-else>なし</p>
            </div>
          </v-card-text>
        </v-card>

        <v-card :elevation="0">
          <v-card-item>
            <v-card-title class="text-subtitle-2">モジュール再起動</v-card-title>
          </v-card-item>

          <v-card-text>
            <v-divider class="mt-n1"></v-divider>

            <div class="my-4 mx-1">
              <p class="mb-3">定期再起動設定</p>

              <v-card variant="outlined" v-if="rebootAt">
                <v-card-text>
                  毎日&nbsp;{{ rebootAt }}&nbsp;に再起動
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn color="error" v-on:click="isShowUnsetRebootConfirmDialog = true;">
                    設定を解除する
                  </v-btn>
                </v-card-actions>
              </v-card>

              <div class="mx-1" v-else>
                <p class="ms-1 text-subtitle-1 font-weight-bold">なし</p>

                <v-row class="mt-8">
                  <v-col :cols="$vuetify.display.mobile ? 12 : 1" class="d-flex align-center">
                    毎日
                  </v-col>
                  <v-col :cols="$vuetify.display.mobile ? 5 : 2">
                    <v-select density="compact" hide-details :items="[
                      { title: '00', value: '00' },
                      { title: '01', value: '01' },
                      { title: '02', value: '02' },
                      { title: '03', value: '03' },
                      { title: '04', value: '04' },
                      { title: '05', value: '05' },
                      { title: '06', value: '06' },
                      { title: '07', value: '07' },
                      { title: '08', value: '08' },
                      { title: '09', value: '09' },
                      { title: '10', value: '10' },
                      { title: '11', value: '11' },
                      { title: '12', value: '12' },
                      { title: '13', value: '13' },
                      { title: '14', value: '14' },
                      { title: '15', value: '15' },
                      { title: '16', value: '16' },
                      { title: '17', value: '17' },
                      { title: '18', value: '18' },
                      { title: '19', value: '19' },
                      { title: '20', value: '20' },
                      { title: '21', value: '21' },
                      { title: '22', value: '22' },
                      { title: '23', value: '23' },
                    ]" v-model:model-value="rebootScheduleHour"></v-select>
                  </v-col>
                  <v-col :cols="$vuetify.display.mobile ? 2 : 1" class="d-flex align-center justify-center">
                    :
                  </v-col>
                  <v-col :cols="$vuetify.display.mobile ? 5 : 2">
                    <v-select density="compact" hide-details :items="[
                      { title: '00', value: '00' },
                      { title: '01', value: '01' },
                      { title: '02', value: '02' },
                      { title: '03', value: '03' },
                      { title: '04', value: '04' },
                      { title: '05', value: '05' },
                      { title: '06', value: '06' },
                      { title: '07', value: '07' },
                      { title: '08', value: '08' },
                      { title: '09', value: '09' },
                      { title: '10', value: '10' },
                      { title: '11', value: '11' },
                      { title: '12', value: '12' },
                      { title: '13', value: '13' },
                      { title: '14', value: '14' },
                      { title: '15', value: '15' },
                      { title: '16', value: '16' },
                      { title: '17', value: '17' },
                      { title: '18', value: '18' },
                      { title: '19', value: '19' },
                      { title: '20', value: '20' },
                      { title: '21', value: '21' },
                      { title: '22', value: '22' },
                      { title: '23', value: '23' },
                      { title: '24', value: '24' },
                      { title: '25', value: '25' },
                      { title: '26', value: '26' },
                      { title: '27', value: '27' },
                      { title: '28', value: '28' },
                      { title: '29', value: '29' },
                      { title: '30', value: '30' },
                      { title: '31', value: '31' },
                      { title: '32', value: '32' },
                      { title: '33', value: '33' },
                      { title: '34', value: '34' },
                      { title: '35', value: '35' },
                      { title: '36', value: '36' },
                      { title: '37', value: '37' },
                      { title: '38', value: '38' },
                      { title: '39', value: '39' },
                      { title: '40', value: '40' },
                      { title: '41', value: '41' },
                      { title: '42', value: '42' },
                      { title: '43', value: '43' },
                      { title: '44', value: '44' },
                      { title: '45', value: '45' },
                      { title: '46', value: '46' },
                      { title: '47', value: '47' },
                      { title: '48', value: '48' },
                      { title: '49', value: '49' },
                      { title: '50', value: '50' },
                      { title: '51', value: '51' },
                      { title: '52', value: '52' },
                      { title: '53', value: '53' },
                      { title: '54', value: '54' },
                      { title: '55', value: '55' },
                      { title: '56', value: '56' },
                      { title: '57', value: '57' },
                      { title: '58', value: '58' },
                      { title: '59', value: '59' }
                    ]" v-model:model-value="rebootScheduleMinutes"></v-select>
                  </v-col>
                  <v-col :cols="$vuetify.display.mobile ? 12 : 2" class="d-flex align-center">
                    に再起動
                  </v-col>
                  <v-col :cols="$vuetify.display.mobile ? 12 : 2" class="d-flex align-center">
                    <v-btn variant="tonal" color="primary"
                      v-on:click="isShowSetRebootConfirmDialog = true;">
                      設定する
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-card-text>

          <v-card-actions class="pa-4 justify-end">
            <v-btn variant="outlined" color="error" class="px-3"
              v-on:click="isShowRebootConfirmDialog = true;">
              再起動コマンド送信
            </v-btn>
          </v-card-actions>
        </v-card>

      </v-col>

    </v-row>
  </v-container>


  <v-dialog persistent max-width="500" v-model="isShowOutputConfirmDialog">
    <v-card>
      <v-card-item>
        <v-card-title>出力指示を送信します</v-card-title>
      </v-card-item>

      <v-card-text>

        <v-card variant="outlined" class="mt-3" v-if="('do1' in commandPayload)">
          <v-card-item>
            <v-card-title class="text-subtitle-1">
              {{ output1ChannelName }}
            </v-card-title>
          </v-card-item>
          <v-card-text>
            <p class="text-right text-h5">
              {{ commandPayload.do1.val === 1 ? 'ON' : 'OFF' }}
            </p>
            <p class="text-right text-subtitle-2">
              ({{ output1Meanings[commandPayload.do1.val] }})
            </p>
            <p class="ma-1" v-if="hasOutput1Duration">
              出力継続時間：&nbsp;{{ output1Duration.toString() + (output1DurationUnit === 'mSec' ? '00 ミリ秒' : ' 秒' ) }}
            </p>
          </v-card-text>
        </v-card>

        <v-card variant="outlined" class="mt-3" v-if="('do2' in commandPayload)">
          <v-card-item>
            <v-card-title class="text-subtitle-1">
              {{ output2ChannelName }}
            </v-card-title>
          </v-card-item>
          <v-card-text>
            <p class="text-right text-h5">
              {{ commandPayload.do2.val === 1 ? 'ON' : 'OFF' }}
            </p>
            <p class="text-right text-subtitle-2">
              ({{ output2Meanings[commandPayload.do2.val] }})
            </p>
            <p class="ma-1" v-if="hasOutput2Duration">
              出力継続時間：&nbsp;{{ output2Duration.toString() + (output2DurationUnit === 'mSec' ? '00 ミリ秒' : ' 秒' ) }}
            </p>
          </v-card-text>
        </v-card>

        <v-switch color="primary" hide-details v-model="isScheduleCommand" class="mt-3"
          v-if="!(('do1' in commandPayload) && ('do2' in commandPayload))" :readonly="isSendingCommand">
          <template v-slot:label>
            実行日時を指定する
          </template>
        </v-switch>

        <vue-date-picker v-model="scheduleDatetime"
          :min-date="minScheduleDatetime" :format="formatScheduleDatetime" :clearable="false"
          locale="ja" week-start="0" minutes-grid-increment="1"
          auto-apply teleport-center
          class="mt-1" v-bind:class="{ 'v-hidden': !isScheduleCommand }"
          :readonly="isSendingCommand"></vue-date-picker>

      </v-card-text>

      <v-card-actions class="pa-4 justify-space-between">
        <v-btn v-bind:class="{ 'v-hidden': isSendingCommand }"
          v-on:click="startCountdownAutoDisconnect(); isShowOutputConfirmDialog = false;">
          キャンセル
        </v-btn>
        <v-btn variant="flat" color="primary"
          v-on:click="sendOutputCommand" :loading="isSendingCommand">
          内容を確認の上で実行
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>


  <v-dialog persistent max-width="500" v-model="isShowCancelScheduleConfirmDialog">
    <v-card>
      <v-card-text>
        選択した出力予約をキャンセルします。よろしいですか？
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn v-on:click="isShowCancelScheduleConfirmDialog = false;" v-if="!isSendingCommand">
          キャンセルしない
        </v-btn>
        <v-btn color="error"
          v-on:click="sendCancelScheduleCommand" :loading="isSendingCommand">
          キャンセルする
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>


  <v-dialog persistent max-width="500" v-model="isShowSetRebootConfirmDialog">
    <v-card>
      <v-card-text>
        毎日&nbsp;{{ rebootScheduleHour }}:{{ rebootScheduleMinutes }}&nbsp;に定期再起動を設定します。よろしいですか？
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn v-on:click="isShowSetRebootConfirmDialog = false;" v-if="!isSendingCommand">
          キャンセル
        </v-btn>
        <v-btn color="primary" v-on:click="sendSetRebootCommand" :loading="isSendingCommand">
          設定する
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog persistent max-width="500" v-model="isShowUnsetRebootConfirmDialog">
    <v-card>
      <v-card-text>
        定期再起動の設定を解除します。よろしいですか？
      </v-card-text>

      <v-card-actions class="justify-space-between">
        <v-btn v-on:click="isShowUnsetRebootConfirmDialog = false;" v-bind:class="{ 'v-hidden': isSendingCommand }">
          キャンセル
        </v-btn>
        <v-btn color="error" v-on:click="sendUnsetRebootCommand" :loading="isSendingCommand">
          解除する
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog persistent max-width="500" v-model="isShowRebootConfirmDialog">
    <v-card>
      <v-card-text>
        即座にモジュールを再起動します。よろしいですか？
      </v-card-text>

      <v-card-actions class="justify-space-between">
        <v-btn v-on:click="isShowRebootConfirmDialog = false;" v-bind:class="{ 'v-hidden': isSendingCommand }">
          キャンセル
        </v-btn>
        <v-btn color="error" v-on:click="sendRebootCommand" :loading="isSendingCommand">
          再起動を実行
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>


  <v-dialog persistent max-width="500" v-model="isShowRebootStartMessage">
    <v-card>
      <v-card-item>
        <v-card-title>接続を解除しました</v-card-title>
      </v-card-item>
      <v-card-text>
        <p>モジュールの再起動が開始されました</p>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn v-on:click="isShowRebootStartMessage = false;">
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>


  <v-dialog persistent max-width="500" v-model="isShowConnectionTimedOutMessage">
    <v-card>
      <v-card-item>
        <v-card-title>接続に失敗しました</v-card-title>
      </v-card-item>
      <v-card-text>
        <p>モジュールからの応答がありません</p>
        <p>操作対象モジュールの電源が入っているか、インターネットに接続しているかをご確認ください</p>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn v-on:click="isShowConnectionTimedOutMessage = false;">
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog persistent max-width="500" v-model="isShowOutputCommandTimeoutMessage">
    <v-card color="error">
      <v-card-item>
        <v-card-title>出力指示エラー</v-card-title>
      </v-card-item>
      <v-card-text>
        <p>モジュールからの応答を確認できませんでした。モジュールの状態をご確認ください</p>
        <br>
        <p>
          モジュール側では出力処理が実行されている可能性もございます。<!--
       -->2回出力を行ってはいけない場合には、ただちにコマンド送信のリトライは行わずに、しばらくしてから動作ログをご確認ください
        </p>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn v-on:click="isShowOutputCommandTimeoutMessage = false;">
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog persistent max-width="500" v-model="isShowCommandTimeoutMessage">
    <v-card color="error">
      <v-card-item>
        <v-card-title>コマンド通信エラー</v-card-title>
      </v-card-item>
      <v-card-text>
        <p>モジュールからの応答を確認できませんでした。モジュールの状態をご確認ください</p>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn v-on:click="isShowCommandTimeoutMessage = false;">
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog persistent max-width="500" v-model="isShowAutoDisconnectMessage">
    <v-card>
      <v-card-item>
        <v-card-title>接続を解除しました</v-card-title>
      </v-card-item>
      <v-card-text>
        <p>画面を一定時間操作されなかったため、モジュールとの接続を解除しました</p>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn v-on:click="isShowAutoDisconnectMessage = false;">
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog persistent max-width="500" v-model="isShowPermissionErrorMessage">
    <v-card>
      <v-card-item>
        <v-card-title>接続に失敗しました</v-card-title>
      </v-card-item>
      <v-card-text>
        <p>接続に必要な権限設定が不足している可能性があります</p>
        <p>このメッセージが繰り返し表示される際は、クラウド管理者までお問い合わせください</p>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn v-on:click="isShowPermissionErrorMessage = false;">
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog persistent max-width="500" v-model="isShowConnectionLostMessage">
    <v-card>
      <v-card-item>
        <v-card-title>接続が解除されました</v-card-title>
      </v-card-item>
      <v-card-text>
        <p>お使いの端末のインターネット接続をご確認ください</p>
        <p>他の端末から同一のモジュールに対する操作が開始された場合にも、このメッセージが表示されます</p>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn v-on:click="isShowConnectionLostMessage = false;">
          閉じる
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, onMounted, onBeforeUnmount, watch } from 'vue';

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

import axios from 'axios';

import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';
import { SignatureV4 } from '@smithy/signature-v4';
import { Sha256 } from '@aws-crypto/sha256-js';
import { HttpRequest } from '@smithy/protocol-http';

import mqtt from 'mqtt/dist/mqtt.min';

import config from '@/config.js';

export default {
  name: 'RemoteControlView',
  components: {
    VueDatePicker
  },

  setup() {

    const moduleID = ref('');
    const operableModules = ref([
      { title: '未選択', value: '' }
    ]);

    const isConnecting = ref(false);
    const isConnected = ref(false);

    const isSendingCommand = ref(false);

    const commandPayload = ref({});

    const isManualDisconnect = ref(false);
    const isAutoDisconnect = ref(false);

    const operationLogList = ref([]);

    const output1ChannelName = ref('デジタル出力1');
    const output1Meanings = ref({
      1: 'ON',
      0: 'OFF'
    });

    const output1Value = ref(-1);

    const output1CommandForm = ref();

    const output1Command = ref('ON');
    const hasOutput1Duration = ref(false);
    const output1Duration = ref('1');
    const output1DurationUnit = ref('mSec');

    const output2ChannelName = ref('デジタル出力2');
    const output2Meanings = ref({
      1: 'ON',
      0: 'OFF'
    });

    const output2Value = ref(-1);

    const output2CommandForm = ref();

    const output2Command = ref('ON');
    const hasOutput2Duration = ref(false);
    const output2Duration = ref('1');
    const output2DurationUnit = ref('mSec');

    const output1Schedule = ref(null);

    const output2Schedule = ref(null);

    const rebootAt = ref(null);

    const rebootScheduleHour = ref('00');
    const rebootScheduleMinutes = ref('00');

    const isShowOutputConfirmDialog = ref(false);

    const isScheduleCommand = ref(false);
    const scheduleDatetime = ref(null);
    const minScheduleDatetime = ref(null);

    const isShowCancelScheduleConfirmDialog = ref(false);

    const cancelTargetSchedule = ref('');

    const isShowSetRebootConfirmDialog = ref(false);
    const isShowUnsetRebootConfirmDialog = ref(false);

    const isShowRebootConfirmDialog = ref(false);

    const isShowRebootStartMessage = ref(false);

    const isShowConnectionTimedOutMessage = ref(false);
    const isShowOutputCommandTimeoutMessage = ref(false);
    const isShowCommandTimeoutMessage = ref(false);
    const isShowAutoDisconnectMessage = ref(false);
    const isShowPermissionErrorMessage = ref(false);
    const isShowConnectionLostMessage = ref(false);


    var mqttClient;

    var connectionTimeoutID;

    var autoDisconnectTimeoutID;

    var commandTimeoutID;


    onMounted(() => {
      fetchModuleList();

      watch(output1Command, () => {
        if (isConnected.value) {
          startCountdownAutoDisconnect();
        }
      });

      watch(hasOutput1Duration, () => {
        if (isConnected.value) {
          startCountdownAutoDisconnect();
        }
      });

      watch(output1Duration, () => {
        if (isConnected.value) {
          startCountdownAutoDisconnect();
        }
      });

      watch(output1DurationUnit, () => {
        if (isConnected.value) {
          startCountdownAutoDisconnect();
        }
      });

      watch(output2Command, () => {
        if (isConnected.value) {
          startCountdownAutoDisconnect();
        }
      });

      watch(hasOutput2Duration, () => {
        if (isConnected.value) {
          startCountdownAutoDisconnect();
        }
      });

      watch(output2Duration, () => {
        if (isConnected.value) {
          startCountdownAutoDisconnect();
        }
      });

      watch(output2DurationUnit, () => {
        if (isConnected.value) {
          startCountdownAutoDisconnect();
        }
      });

    });

    const fetchModuleList = () => {

      axios.get(
        config.API_URL +
        `/users/me`,
        { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem("access-token") } }
      ).then((response) => {

        response.data.configurableModules.forEach((moduleID) => {
          operableModules.value.push({
            title: moduleID,
            value: moduleID
          });
        });

      }).catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

    };

    onBeforeUnmount(() => {

      if (mqttClient != null) {
        mqttClient.end();
      }

    });


    const connect = async () => {

      isConnecting.value = true;

      const credentials = await fromCognitoIdentityPool({
        clientConfig: { region: 'ap-northeast-1' },
        identityPoolId: config.COGNITO_IDENTITY_POOL_ID,
        logins: {
          ['cognito-idp.ap-northeast-1.amazonaws.com/' + config.COGNITO_USER_POOL_ID]: window.sessionStorage.getItem("access-token")
        }
      })().catch((/* error */) => {
        // TBD リフレッシュトークンの利用を検討
        window.sessionStorage.clear();
        window.sessionStorage.setItem('access-token-expired', 'true');

        window.location.reload();
      });

      if (!credentials) return;


      const sigV4 = new SignatureV4({
        sha256: Sha256,

        region: 'ap-northeast-1',
        service: 'iotdevicegateway',
        credentials: {
          accessKeyId: credentials.accessKeyId,
          secretAccessKey: credentials.secretAccessKey
        }
      });

      const signedRequest = await sigV4.presign(new HttpRequest({
        method: 'GET',
        headers: {
          host: config.AWS_IOT_ENDPOINT
        },
        path: '/mqtt'
      }));

      signedRequest.query['X-Amz-Security-Token'] = credentials.sessionToken;

      const brokerURL = 'wss://' + config.AWS_IOT_ENDPOINT + signedRequest.path +
        '?' + new URLSearchParams(signedRequest.query).toString();


      mqttClient = mqtt.connect(brokerURL, {
        reconnectPeriod: 0,
        clientId: moduleID.value + '_operator'
      });

      mqttClient.stream.on('close', () => {

        if (isManualDisconnect.value) {

          // Do Nothing
          isManualDisconnect.value = false;

        } else if (isAutoDisconnect.value) {

          isAutoDisconnect.value = false;

          isShowAutoDisconnectMessage.value = true;

        } else if (isConnecting.value) {

          isShowPermissionErrorMessage.value = true;

        } else {

          isShowConnectionLostMessage.value = true;

        }


        resetScreen();

      });


      mqttClient.on('connect', () => {

        mqttClient.subscribe('command/' + moduleID.value, (error) => {
          if (error) return;

          mqttClient.subscribe('status/' + moduleID.value + '/+', (error) => {
            if (error) return;

            axios.get(
              config.API_URL +
              `/modules/${ moduleID.value }/channels`,
              { headers: { Authorization: 'Bearer ' + window.sessionStorage.getItem("access-token") } }
            ).then((response) => {

              output1ChannelName.value = response.data.channels.do1.name;

              output1Meanings.value = {
                1: response.data.channels.do1.highMeaning,
                0: response.data.channels.do1.lowMeaning
              };

              output2ChannelName.value = response.data.channels.do2.name;

              output2Meanings.value = {
                1: response.data.channels.do2.highMeaning,
                0: response.data.channels.do2.lowMeaning
              };


              connectionTimeoutID = setTimeout(() => {

                disconnect();
                isShowConnectionTimedOutMessage.value = true;

              }, 10 * 1000);

              mqttClient.publish(
                'command/' + moduleID.value,
                JSON.stringify({
                  cmd: 'reqCurrentStatus',
                  id: crypto.randomUUID().split('-')[0]
                })
              );

            }).catch((/* error */) => {
              // TBD リフレッシュトークンの利用を検討
              window.sessionStorage.clear();
              window.sessionStorage.setItem('access-token-expired', 'true');

              window.location.reload();
            });

          });
        });

      });

      mqttClient.on('message', (topic, message) => {

        if (topic.startsWith('status')) {

          const statusMessage = JSON.parse(message.toString());

          switch (statusMessage.type) {

            case 'currentStatus':

              if (isConnecting.value) {
                clearTimeout(connectionTimeoutID);

                isConnecting.value = false;
                isConnected.value = true;

                startCountdownAutoDisconnect();
              }

              output1Value.value = statusMessage.do1;
              output2Value.value = statusMessage.do2;

              if ('schedule' in statusMessage) {

                output1Schedule.value = ('do1' in statusMessage.schedule) ? statusMessage.schedule.do1 : null;
                output2Schedule.value = ('do2' in statusMessage.schedule) ? statusMessage.schedule.do2 : null;

              } else {
                output1Schedule.value = null;
                output2Schedule.value = null;
              }

              rebootAt.value = ('rebootAt' in statusMessage) ? statusMessage.rebootAt : null;

              break;

            case 'notifyAction':

              if (isSendingCommand.value) {

                if (statusMessage.id === commandPayload.value.id) {
                  clearTimeout(commandTimeoutID);

                  isSendingCommand.value = false;
                  isShowOutputConfirmDialog.value = false;
                }

              }

              output1Value.value = statusMessage.result.do1;
              output2Value.value = statusMessage.result.do2;

              if (statusMessage.trigger === 'schedule') {

                if (output1Schedule.value) {
                  if (output1Schedule.value.id === statusMessage.id) {
                    output1Schedule.value = null;
                  }
                }

                if (output2Schedule.value) {
                  if (output2Schedule.value.id === statusMessage.id) {
                    output2Schedule.value = null;
                  }
                }

              }

              operationLogList.value.unshift({
                timestamp: statusMessage.time,
                payload: statusMessage
              });

              break;

            case 'ackCommand':

              if (statusMessage.id === commandPayload.value.id) {
                clearTimeout(commandTimeoutID);

                isSendingCommand.value = false;

                switch (commandPayload.value.cmd) {

                  case 'setSchedule':

                    isShowOutputConfirmDialog.value = false;

                    if (commandPayload.value.target === 'do1') {
                      output1Schedule.value = commandPayload.value;
                    } else {
                      output2Schedule.value = commandPayload.value;
                    }

                    break;

                  case 'cancelSchedule':

                    isShowCancelScheduleConfirmDialog.value = false;

                    if (commandPayload.value.target === 'do1') {
                      output1Schedule.value = null;
                    } else {
                      output2Schedule.value = null;
                    }

                    break;

                  case 'setReboot':

                    isShowSetRebootConfirmDialog.value = false;

                    rebootAt.value = commandPayload.value.rebootAt;

                    break;

                  case 'unsetReboot':

                    isShowUnsetRebootConfirmDialog.value = false;

                    rebootAt.value = null;

                    break;

                  case 'reboot':

                    disconnect();

                    isShowRebootStartMessage.value = true;

                    break;

                }
              }

              operationLogList.value.unshift({
                timestamp: formatDatetime(new Date()),
                payload: statusMessage
              });

              break;

          }

        } else {

          const commandMessage = JSON.parse(message.toString());

          switch (commandMessage.cmd) {

            case 'output':
            case 'setSchedule':
            case 'cancelSchedule':
            case 'setReboot':
            case 'unsetReboot':
            case 'reboot':

              operationLogList.value.unshift({
                timestamp: formatDatetime(new Date()),
                payload: commandMessage
              });

              break;

          }

        }

      });

    };

    const disconnect = () => {
      isManualDisconnect.value = true;
      mqttClient.end();
    };

    const resetScreen = () => {

      clearTimeout(autoDisconnectTimeoutID);

      isConnecting.value = false;
      isConnected.value = false;

      isSendingCommand.value = false;

      operationLogList.value = [];

      output1Value.value = -1;

      output1Command.value = 'ON';
      hasOutput1Duration.value = false;
      output1Duration.value = '1';
      output1DurationUnit.value = 'mSec';

      output2Value.value = -1;

      output2Command.value = 'ON';
      hasOutput2Duration.value = false;
      output2Duration.value = '1';
      output2DurationUnit.value = 'mSec';

      isShowOutputConfirmDialog.value = false;

      isShowCancelScheduleConfirmDialog.value = false;

      isShowSetRebootConfirmDialog.value = false;
      isShowUnsetRebootConfirmDialog.value = false;

      isShowRebootConfirmDialog.value = false;

    };

    const startCountdownAutoDisconnect = () => {

      clearTimeout(autoDisconnectTimeoutID);

      autoDisconnectTimeoutID = setTimeout(() => {

        isAutoDisconnect.value = true;
        mqttClient.end();

      }, 3 * 60 * 1000);

    };

    const convertToFriendlyText = (payload) => {

      let text = '異常なログが記録されています。クラウド管理者にご連絡ください';

      if ('cmd' in payload) {

        switch (payload.cmd) {

          case 'output':

            text = `出力指示を送信`;

            if ('do1' in payload) {
              text += `（デジタル出力1を`;

              if ('duration' in payload.do1) {
                if (payload.do1.duration % 10 === 0) {
                  text += `${ (payload.do1.duration / 10).toString() }秒間`;
                } else {
                  text += `${ payload.do1.duration.toString() }00ミリ秒間`;
                }
              }

              text += `${ (payload.do1.val === 1) ? 'ON' : 'OFF' }）`;
            }

            if ('do2' in payload) {
              text += `（デジタル出力2を`;

              if ('duration' in payload.do2) {
                if (payload.do2.duration % 10 === 0) {
                  text += `${ (payload.do2.duration / 10).toString() }秒間`;
                } else {
                  text += `${ payload.do2.duration.toString() }00ミリ秒間`;
                }
              }

              text += `${ (payload.do2.val === 1) ? 'ON' : 'OFF' }）`;
            }

            break;

          case 'setSchedule':

            text = `出力予約指示を送信`;

            text += `（デジタル出力${ payload.target.substring(2) }, ${ payload.time }に`;

            if ('duration' in payload.action) {
              if (payload.action.duration % 10 === 0) {
                text += `${ (payload.action.duration / 10).toString() }秒間`;
              } else {
                text += `${ payload.action.duration.toString() }00ミリ秒間`;
              }
            }

            text += `${ (payload.action.val === 1) ? 'ON' : 'OFF' }）`;

            break;

          case 'cancelSchedule':

            text = `出力予約キャンセル指示を送信`;

            text += `（デジタル出力${ payload.target.substring(2) }）`;

            break;

          case 'setReboot':

            text = `定期再起動の設定指示を送信`;

            text += `（毎日 ${ payload.rebootAt }）`;

            break;

          case 'unsetReboot':

            text = `定期再起動の設定解除指示を送信`;

            break;

          case 'reboot':

            text = `再起動指示を送信`;

            break;

        }

      } else {

        switch (payload.type) {

          case 'notifyAction':

            switch (payload.trigger) {

              case 'manual':

                text = `出力を実行`;

                break;

              case 'schedule':

                text = `出力予約を実行`;

                break;

              case 'alarm':

                text = `${ payload.alarm.inputChannel.startsWith('a') ? 'アナログ' : 'デジタル入力' }${ payload.alarm.inputChannel.substring(1) }の計測値が`;

                if (payload.alarm.condition === 0) {

                  text += `正常範囲に復帰したため`;

                } else  {

                  if (payload.alarm.condition > 0) {
                    text += `上限値${ payload.alarm.condition.toString() }段階目以上となったため`;
                  } else {
                    text += `下限値${ Math.abs(payload.alarm.condition).toString() }段階目以下となったため`;
                  }

                }

                text += `、アラーム設定による出力を実行`;

                break;

            }

            for (let i = 0; i < payload.actions.length; i++) {
              text += `（デジタル出力${ payload.actions[i].target.substring(2) }`;

              if ('duration' in payload.actions[i]) {
                if (payload.actions[i].duration.amount % 10 === 0) {
                  text += `の${ (payload.actions[i].duration.amount / 10).toString() }秒間`;
                } else {
                  text += `の${ payload.actions[i].duration.amount.toString() }00ミリ秒間`;
                }

                text += `${ (payload.actions[i].outputVal === 1) ? 'ON' : 'OFF' }`;
                text += `を${ (payload.actions[i].duration.timing === 'start') ? '開始' : '終了' }）`;
              } else {
                text += `を${ (payload.actions[i].outputVal === 1) ? 'ON' : 'OFF' }）`;
              }
            }

            break;

          case 'ackCommand':

            text = `指示を受け付け`;

            break;

        }

      }

      return text;

    };

    const showOutputConfirmDialog = async (includesOutput1, includesOutput2) => {

      startCountdownAutoDisconnect();

      const output1FormValidateResult = await output1CommandForm.value.validate();
      const output2FormValidateResult = await output2CommandForm.value.validate();

      commandPayload.value = {
        cmd: 'output',
        id: crypto.randomUUID().split('-')[0]
      };

      if (includesOutput1) {
        if (!output1FormValidateResult.valid) return;

        const do1 = {
          val: (output1Command.value === 'ON') ? 1 : 0
        };

        if (hasOutput1Duration.value) {
          do1.duration = Number(output1Duration.value);

          if (output1DurationUnit.value === 'sec') {
            do1.duration = do1.duration * 10;
          }
        }

        commandPayload.value.do1 = do1;

      }

      if (includesOutput2) {
        if (!output2FormValidateResult.valid) return;

        const do2 = {
          val: (output2Command.value === 'ON') ? 1 : 0
        };

        if (hasOutput2Duration.value) {
          do2.duration = Number(output2Duration.value);

          if (output2DurationUnit.value === 'sec') {
            do2.duration = do2.duration * 10;
          }
        }

        commandPayload.value.do2 = do2;

      }

      isScheduleCommand.value = false;

      const now = new Date();

      scheduleDatetime.value = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        now.getHours(),
        now.getMinutes() + 5
      );

      minScheduleDatetime.value = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        now.getHours(),
        now.getMinutes() + 3
      );

      isShowOutputConfirmDialog.value = true;

    };

    const formatScheduleDatetime = (date) => {

      const year = date.getFullYear().toString();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');

      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes;

    };

    const sendOutputCommand = () => {

      isSendingCommand.value = true;

      startCountdownAutoDisconnect();


      let payload = commandPayload.value;

      if (isScheduleCommand.value) {

        commandPayload.value.cmd = 'setSchedule';

        commandPayload.value.time = formatScheduleDatetime(scheduleDatetime.value);

        if ('do1' in commandPayload.value) {
          commandPayload.value.target = 'do1';
          commandPayload.value.action = commandPayload.value.do1;

          payload = structuredClone(commandPayload.value);
          delete payload.do1;

        } else {
          commandPayload.value.target = 'do2';
          commandPayload.value.action = commandPayload.value.do2;

          payload = structuredClone(commandPayload.value);
          delete payload.do2;

        }

      }


      commandTimeoutID = setTimeout(() => {

        disconnect();

        if (commandPayload.value.cmd === 'output') {
          isShowOutputCommandTimeoutMessage.value = true;
        } else {
          isShowCommandTimeoutMessage.value = true;
        }

      }, 10 * 1000);

      mqttClient.publish(
        'command/' + moduleID.value,
        JSON.stringify(payload)
      );

    };

    const sendCancelScheduleCommand = () => {

      isSendingCommand.value = true;

      startCountdownAutoDisconnect();

      commandPayload.value = {
        cmd: 'cancelSchedule',
        id: crypto.randomUUID().split('-')[0],
        target: cancelTargetSchedule.value
      };

      commandTimeoutID = setTimeout(() => {

        disconnect();
        isShowCommandTimeoutMessage.value = true;

      }, 10 * 1000);

      mqttClient.publish(
        'command/' + moduleID.value,
        JSON.stringify(commandPayload.value)
      );

    };

    const sendSetRebootCommand = () => {

      isSendingCommand.value = true;

      startCountdownAutoDisconnect();

      commandPayload.value = {
        cmd: 'setReboot',
        id: crypto.randomUUID().split('-')[0],
        rebootAt: rebootScheduleHour.value + ':' + rebootScheduleMinutes.value
      };

      commandTimeoutID = setTimeout(() => {

        disconnect();
        isShowCommandTimeoutMessage.value = true;

      }, 10 * 1000);

      mqttClient.publish(
        'command/' + moduleID.value,
        JSON.stringify(commandPayload.value)
      );

    };

    const sendUnsetRebootCommand = () => {

      isSendingCommand.value = true;

      startCountdownAutoDisconnect();

      commandPayload.value = {
        cmd: 'unsetReboot',
        id: crypto.randomUUID().split('-')[0]
      };

      commandTimeoutID = setTimeout(() => {

        disconnect();
        isShowCommandTimeoutMessage.value = true;

      }, 10 * 1000);

      mqttClient.publish(
        'command/' + moduleID.value,
        JSON.stringify(commandPayload.value)
      );

    };

    const sendRebootCommand = () => {

      isSendingCommand.value = true;

      startCountdownAutoDisconnect();

      commandPayload.value = {
        cmd: 'reboot',
        id: crypto.randomUUID().split('-')[0]
      };

      commandTimeoutID = setTimeout(() => {

        disconnect();
        isShowCommandTimeoutMessage.value = true;

      }, 10 * 1000);

      mqttClient.publish(
        'command/' + moduleID.value,
        JSON.stringify(commandPayload.value)
      );

    };

    const formatDatetime = (date) => {

      const year = date.getFullYear().toString();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');

      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');

      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;

    };


    return {
      moduleID,
      operableModules,

      isConnecting,
      isConnected,

      isSendingCommand,

      commandPayload,

      operationLogList,

      output1ChannelName,
      output1Meanings,

      output1Value,

      output1CommandForm,

      output1Command,
      hasOutput1Duration,
      output1Duration,
      output1DurationUnit,

      output2ChannelName,
      output2Meanings,

      output2Value,

      output2CommandForm,

      output2Command,
      hasOutput2Duration,
      output2Duration,
      output2DurationUnit,

      output1Schedule,

      output2Schedule,

      rebootAt,

      rebootScheduleHour,
      rebootScheduleMinutes,

      isShowOutputConfirmDialog,

      isScheduleCommand,
      scheduleDatetime,
      minScheduleDatetime,

      isShowCancelScheduleConfirmDialog,

      cancelTargetSchedule,

      isShowSetRebootConfirmDialog,
      isShowUnsetRebootConfirmDialog,

      isShowRebootConfirmDialog,

      isShowRebootStartMessage,

      isShowConnectionTimedOutMessage,
      isShowOutputCommandTimeoutMessage,
      isShowCommandTimeoutMessage,
      isShowAutoDisconnectMessage,
      isShowPermissionErrorMessage,
      isShowConnectionLostMessage,

      connect,
      disconnect,

      startCountdownAutoDisconnect,

      convertToFriendlyText,

      showOutputConfirmDialog,

      formatScheduleDatetime,

      sendOutputCommand,

      sendCancelScheduleCommand,

      sendSetRebootCommand,
      sendUnsetRebootCommand,

      sendRebootCommand
    }

  }
}
</script>

